import { useEffect, useRef } from 'react';
import { GridApi, IRowNode } from 'ag-grid-community';
import { ScenarioDetailRow } from '@queries/scenarios';

const editableGridButtonsHeight = 48;
const footerWithRowsCountHeight = 48;
const standardRowHeight = 25;
const minRowsToShow = 14; // it includes headers
const maxRowsToShow = 25; // it includes headers

const getInnerContainerHeight = (rowsCount: number) =>
  Math.min(maxRowsToShow, Math.max(rowsCount, minRowsToShow)) * standardRowHeight;

export const getDetailsRowHeight = (rowsCount: number) =>
  getInnerContainerHeight(rowsCount) + editableGridButtonsHeight + footerWithRowsCountHeight;

export const useAdjustGridSizeToRows = ({
  parentNode,
  details,
  parentGridApi,
}: {
  parentNode: IRowNode,
  details: ScenarioDetailRow[],
  parentGridApi: GridApi,
}) => {
  const containerRef = useRef<HTMLDivElement|null>(null);

  useEffect(() => {
    if (containerRef.current) {
      const innerContainer = containerRef.current?.querySelector('.ag-grid-custom > .ag-theme-bootstrap > div > div')! as HTMLDivElement;
      innerContainer.style.height = `${getInnerContainerHeight(details.length)}px`;
      parentNode.setRowHeight(getDetailsRowHeight(details.length));
      parentGridApi.onRowHeightChanged();
    }
  }, [details, parentGridApi, parentNode]);

  return {
    containerRef,
  };
};
